module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Question-circle-243a4ea6bee63b7e1607f4d384b3e815.svg";